import { defineStore } from "pinia";
export const useGeneralStore = defineStore("useGeneralStore", {
  state: () => ({
    loading: false,
    loadingCount: 0,
    closable: true,
    snackbar: {
      color: "",
      show: false,
      message: "",
      timeout: 3000,
    },
  }),
  getters: {
    getSnakebar: (state) => state.snackbar,
    // getLoading: (state) => state.loading,
  },
  actions: {
    showSnackbar(message, color) {
      this.snackbar = { message, color, show: true, timeout: 3000 };
    },
    ShowLoading(closable = true) {
      this.loadingCount++;
      this.loading = true;
      this.closable = closable;
      console.log(`[Store] ShowLoading: Count=${this.loadingCount}`);
    },
    HideLoading() {
      this.loadingCount = Math.max(0, this.loadingCount - 1);
      if (this.loadingCount === 0) {
        this.loading = false;
      }
      console.log(`[Store] HideLoading: Count=${this.loadingCount}`);
    },
    ForceResetLoading() {
      this.loadingCount = 0;
      this.loading = false;
      console.log("[Store] ForceResetLoading triggered");
    },
  },
});
